import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Lightning, UserPlus } from '@phosphor-icons/react'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass } from '../../nodeCatalog'

const TYPE = 'trigger'
// The chip shows the configured trigger's own glyph; the catalog icon is the default.
const DEFAULT_ICON = nodeIcon(TYPE)

// Legacy 'schedule'/'webhook' nodes fall through to the Lightning default below.
const triggerIcons: Record<string, any> = {
  manual: Lightning,
  contact_added: UserPlus,
}

const TriggerNode: React.FC<NodeProps> = ({ data, selected }) => {
  const Icon = triggerIcons[data.trigger_type] || DEFAULT_ICON

  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Trigger</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'Start Trigger'}</p>
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        className={nodeHandleClass(TYPE)}
      />
    </div>
  )
}

export default memo(TriggerNode)
